<template>
    <l-layout :layout="['xs12']">
      <v-card>
        <v-tabs grow v-model="tab">
          <v-tab key="white">白名单</v-tab>
          <v-tab key="black">黑名单</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item key="white">
            <v-layout column class="pt-2">
              <v-layout class="ml-3 mt-1">
                <v-flex xs4>
                  <l-autocomplete
                    :get-data="getUsers"
                    item-text="name"
                    item-sub-text="loginId"
                    label="搜索用户"
                    multiple
                    :init-data="false"
                    prepend-icon="$vuetify.icons.person"
                    v-model="addWhiteList"
                  ></l-autocomplete>
                </v-flex>
                <v-flex xs2>
                  <v-btn flat color="primary" @click="addWhite" :disabled="addWhiteList.length===0">添加白名单</v-btn>
                </v-flex>
              </v-layout>
              <l-data-table
                hide-title-search
                :headers="header"
                ref="whiteList"
                :filter-items="filter_white"
                :get-data-func="getWhiteList"
                v-model="selected_white"
                selectable>
                <template slot="title">
                  <v-btn flat color="primary"  :loading="loading" @click="deleteWhiteTeachersConfirm">批量删除</v-btn>
                  <l-select-file
                    :dialog-props="importFileProps_white"
                    :hint="'仅支持Excel(.xlsx)文件'"
                    @cancel="importFileProps_white.activate = false"
                    @submit="readExcel_white"
                    file-type="excel"
                    select-type="dialog"
                  >
                    <v-btn class="mx-0" color="primary" flat
                           slot="activator" :disabled="disabledFlag">批量导入
                    </v-btn>
                    <template slot="before-drag">
                      <v-layout align-center class="mb-3 pl-2" row>
                        <span class="body-2">批量导入白名单人员需要上传特定格式的模板</span>
                        <v-btn
                          :disabled="disabledFlag"
                          @click="getFileTemplate"
                          color="primary"
                          flat
                          ref="templateBtn"
                          small
                          target="_blank"
                        >点此下载
                        </v-btn>
                      </v-layout>
                    </template>
                  </l-select-file>
                </template>
                <template slot="row-action" slot-scope="{item}">
                  <td @click.stop class="px-0 mx-0 text-xs-center">
                    <v-btn icon  @click="deleteTeacherConfirm(item)">
                      <v-icon small>$vuetify.icons.delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </l-data-table>
              <v-dialog width="1000" v-model="confirmDialog_white.activated">
                <v-layout column>
                  <v-card>
                    <v-card-title>
                      <p class="title">批量导入确认</p>
                    </v-card-title>
                    <v-layout column>
                      <l-data-table
                        :items="addWhiteList"
                        :headers="importHeader"
                        v-show="addWhiteList.length>0"
                        hide-title
                        hide-title-search></l-data-table>
                      <v-layout justify-center>
                        <v-btn class="primary" @click="addWhite('import')" :loading="loading">确定</v-btn>
                        <v-btn class="error" @click="resetImport">取消</v-btn>
                      </v-layout>
                    </v-layout>
                  </v-card>
                </v-layout>
              </v-dialog>
              <v-dialog max-width="1000px" persistent scrollable v-model="importErrorDialog_white.activate">
                <v-card>
                  <v-card-title style="height: 64px;">
                    <span class="title">导入白名单人员发生错误</span>
                  </v-card-title>
                  <v-card-text style="min-height: 350px; max-height: 500px">
                    <div class="mb-4" v-if="importErrorDialog_white.duplicates.length > 0">
                      <div class="subheading py-2">以下人员已在导入列表中</div>
                      <!--<v-divider></v-divider>-->
                      <l-data-table
                        :headers="importHeader"
                        :items="importErrorDialog_white.duplicates"
                        auto-actions
                        flat
                        hide-title
                      ></l-data-table>
                    </div>
                    <div class="mb-4" v-if="importErrorDialog_white.fails.length > 0">
                      <div class="subheading py-2">以下人员导入信息有误</div>
                      <!--<v-divider></v-divider>-->
                      <l-data-table
                        :headers="importErrorHeader"
                        :items="importErrorDialog_white.fails"
                        auto-actions
                        flat
                        hide-title
                      ></l-data-table>
                    </div>
                    <div v-if="importErrorDialog_white.vehicles.length > 0">
                      <div class="py-2">
                        <div class="subheading">以下人员信息正确，等待导入</div>
                        <div class="py-1" v-if="importErrorDialog_white.haveDuplicatePlate">
                          <span class="error--text caption">您导入的模板中含有重复的条目，导入时将以重复数据的第一条为准</span>
                        </div>
                      </div>
                      <!--<v-divider></v-divider>-->
                      <l-data-table
                        :headers="importHeader"
                        :items="importErrorDialog_white.vehicles"
                        auto-actions
                        flat
                        hide-title
                      ></l-data-table>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="importWhiteUsers(0)" color="grey" flat large>取消导入</v-btn>
                    <v-btn :disabled="importErrorDialog_white.vehicles.length === 0"
                           @click="importWhiteUsers(importErrorDialog_white.vehicles)"
                           color="error" flat large>仍然导入
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-layout>
          </v-tab-item>
          <v-tab-item key="black">
            <v-layout column class="pt-2">
              <v-layout class="ml-3 mt-1">
                <v-flex xs4>
                  <l-autocomplete
                    :get-data="getUsers"
                    item-text="name"
                    item-sub-text="loginId"
                    label="搜索用户"
                    multiple
                    prepend-icon="$vuetify.icons.person"
                    v-model="addBlackList"
                  ></l-autocomplete>
                </v-flex>
                <v-flex xs2>
                  <v-btn flat color="primary" @click="addBlack" :disabled="addBlackList.length===0">添加黑名单</v-btn>
                </v-flex>
              </v-layout>
              <l-data-table
                hide-title-search
                :headers="header"
                ref="blackList"
                :get-data-func="getBlackList"
                :filter-items="filter_black"
                v-model="selected_black"
                selectable>
                <template slot="title">
                  <v-btn flat color="primary"  :loading="loading" @click="deleteBlackTeachersConfirm">批量删除</v-btn>
                  <l-select-file
                    :dialog-props="importFileProps_black"
                    :hint="'仅支持Excel(.xlsx)文件'"
                    @cancel="importFileProps_black.activate = false"
                    @submit="readExcel_black"
                    file-type="excel"
                    select-type="dialog"
                  >
                    <v-btn class="mx-0" color="primary" flat
                           slot="activator" :disabled="disabledFlag">批量导入
                    </v-btn>
                    <template slot="before-drag">
                      <v-layout align-center class="mb-3 pl-2" row>
                        <span class="body-2">批量导入黑名单人员需要上传特定格式的模板</span>
                        <v-btn
                          :disabled="disabledFlag"
                          @click="getFileTemplate"
                          color="primary"
                          flat
                          ref="templateBtn"
                          small
                          target="_blank"
                        >点此下载
                        </v-btn>
                      </v-layout>
                    </template>
                  </l-select-file>
                </template>
                <template slot="row-action" slot-scope="{item}">
                  <td @click.stop class="px-0 mx-0 text-xs-center">
                    <v-btn icon  @click="deleteTeacherConfirm(item)">
                      <v-icon small>$vuetify.icons.delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </l-data-table>
            </v-layout>
            <v-dialog width="1000" v-model="confirmDialog_black.activated">
              <v-layout column>
                <v-card>
                  <v-card-title>
                    <p class="title">批量导入确认</p>
                  </v-card-title>
                  <v-layout column>
                    <l-data-table
                      :items="addBlackList"
                      :headers="importHeader"
                      v-show="addBlackList.length>0"
                      hide-title
                      hide-title-search></l-data-table>
                    <v-layout justify-center>
                      <v-btn class="primary" @click="addBlack('import')" :loading="loading">确定</v-btn>
                      <v-btn class="error" @click="resetImport">取消</v-btn>
                    </v-layout>
                  </v-layout>
                </v-card>
              </v-layout>
            </v-dialog>
            <v-dialog max-width="1000px" persistent scrollable v-model="importErrorDialog_black.activate">
              <v-card>
                <v-card-title style="height: 64px;">
                  <span class="title">导入黑名单人员发生错误</span>
                </v-card-title>
                <v-card-text style="min-height: 350px; max-height: 500px">
                  <div class="mb-4" v-if="importErrorDialog_black.duplicates.length > 0">
                    <div class="subheading py-2">以下人员已在导入列表中</div>
                    <!--<v-divider></v-divider>-->
                    <l-data-table
                      :headers="importHeader"
                      :items="importErrorDialog_black.duplicates"
                      auto-actions
                      flat
                      hide-title
                    ></l-data-table>
                  </div>
                  <div class="mb-4" v-if="importErrorDialog_black.fails.length > 0">
                    <div class="subheading py-2">以下人员导入信息有误</div>
                    <!--<v-divider></v-divider>-->
                    <l-data-table
                      :headers="importErrorHeader"
                      :items="importErrorDialog_black.fails"
                      auto-actions
                      flat
                      hide-title
                    ></l-data-table>
                  </div>
                  <div v-if="importErrorDialog_black.vehicles.length > 0">
                    <div class="py-2">
                      <div class="subheading">以下人员信息正确，等待导入</div>
                      <div class="py-1" v-if="importErrorDialog_black.haveDuplicatePlate">
                        <span class="error--text caption">您导入的模板中含有重复的条目，导入时将以重复数据的第一条为准</span>
                      </div>
                    </div>
                    <!--<v-divider></v-divider>-->
                    <l-data-table
                      :headers="importHeader"
                      :items="importErrorDialog_black.vehicles"
                      auto-actions
                      flat
                      hide-title
                    ></l-data-table>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="importBlackUsers(0)" color="grey" flat large>取消导入</v-btn>
                  <v-btn :disabled="importErrorDialog_black.vehicles.length === 0"
                         @click="importBlackUsers(importErrorDialog_black.vehicles)"
                         color="error" flat large>仍然导入
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </l-layout>
</template>

<script>
    import LLayout from "../../ladmin/components/LLayout/LLayout";
    import LDataTable from "../../ladmin/components/LDataTable/LDataTable";
    import LAutocomplete from "../../ladmin/components/LAutocomplete/LAutocomplete";
    import XLSX from 'xlsx'
    function trans(v) {
      switch (v+'') {
        case '2':return '白名单授权';
        case '3': return '黑名单授权'
      }
      return ''
    }
    function errorTrans(v) {
      switch (v+'') {
        case '1':return '工号缺失';
        case '2': return '姓名缺失';
        case '3': return '单位名称缺失'
      }
      return 'N/A'
    }
    export default {
        name: "blackAndWhite",
      components: {LAutocomplete, LDataTable, LLayout},
      data(){
          return {
            filter_white: [
              {
                prependIcon: '$vuetify.icons.person',
                key: 'loginId',
                value: '',
                label: '教工编号',
                type: 'input',
                layout: ['xs12', 'sm4'],
              },
              {
                prependIcon: '$vuetify.icons.person',
                key: 'name',
                value: '',
                label: '教工姓名',
                type: 'input',
                layout: ['xs12', 'sm4'],
              },
            ],
            filter_black: [
              {
                prependIcon: '$vuetify.icons.person',
                key: 'loginId',
                value: '',
                label: '教工编号',
                type: 'input',
                layout: ['xs12', 'sm4'],
              },
              {
                prependIcon: '$vuetify.icons.person',
                key: 'name',
                value: '',
                label: '教工姓名',
                type: 'input',
                layout: ['xs12', 'sm4'],
              },
            ],
            tab:0,
            importFlag:false,
            confirmDialog_white: {
              activated:false,
              hint:''
            },
            confirmDialog_black: {
              activated:false,
              hint:''
            },
            importFileProps_white: {
              activate: true,
              autoClose: true,
              title: '批量导入白名单人员',
            },
            importFileProps_black: {
              activate: true,
              autoClose: true,
              title: '批量导入黑名单人员',
            },
            importFileRules: [
              v => !(!v || v.length === 0) || '必选',
              v => !v.some(f => !/\.xlsx$/i.test(f.name)) || '仅支持Excel表格(.xlsx)格式',
            ],
            importErrorDialog_white: {
              activate: false,
              vehicles: [],
              fails: [],
              duplicates: [],
              haveDuplicatePlate: false,
            },
            importErrorDialog_black: {
              activate: false,
              vehicles: [],
              fails: [],
              duplicates: [],
              haveDuplicatePlate: false,
            },
            disabledFlag:false,
            importHeader:[
              {text:'教工（学生）姓名',value:'name',sortable:false,align:"left"},
              {text:'教工（学生）编号',value:'loginId',sortable:false,align:'left'},
              {text:'手机号码',value:'phone',sortable:false,align:"left"},
              {text:'单位名称',value:'orgName',sortable:false,align:'left'},
            ],
            importErrorHeader:[
              {text:'教工（学生）姓名',value:'name',sortable:false,align:"left"},
              {text:'教工（学生）编号',value:'loginId',sortable:false,align:'left'},
              {text:'手机号码',value:'phone',sortable:false,align:"left"},
              {text:'单位名称',value:'orgName',sortable:false,align:'left'},
              {text:'错误信息',value:'error',sortable:false,align:'left',f:(v)=>errorTrans(v)},
            ],
            header:[
              {text:'教工（学生）姓名',value:'name',sortable:false,align:"left"},
              {text:'教工（学生）编号',value:'loginId',sortable:false,align:'left'},
              {text:'手机号码',value:'phone',sortable:false,align:"left"},
              {text:'单位名称',value:'orgName',sortable:false,align:'left'},
              {text:'授权类型',value:'auditType',sortable:true,align:'left',f:(v)=>trans(v)},
              {text:'',value:'',sortable:false,align:"left"}
            ],
            addBlackList:[],
            addWhiteList:[],
            loading:false,
            selected_white:[],
            selected_black:[],
          }
      },
      methods:{
          async getWhiteList({pagination,filterItems}){
            let {items,amount} = await this.$store.dispatch('school/getApplyList',{filter:filterItems,pagination:pagination,search:{key:'auditType',value:'2'}})
            return {items:items,amount:amount}
          },
          async getBlackList({pagination,filterItems}){
            let {items,amount} = await this.$store.dispatch('school/getApplyList',{filter:filterItems,pagination:pagination,search:{key:'auditType',value:'3'}})
            return {items:items,amount:amount}
          },
        async getFileTemplate () {
          try {
            let url = await this.$store.dispatch('school/getBlackAndWhiteFile')
            let isSupportDownload = 'download' in document.createElement('a')
            console.log('get url', url, isSupportDownload)
            let el = document.createElement('a')
            el.href = url
            el.target = '_blank'
            el.download = '白名单-黑名单导入模板'
            el.style.display = 'none'
            document.body.appendChild(el)
            el.click()
            document.body.removeChild(el)
          }
          catch (e) {
            this.$L.alert('error', {title: '获取模板时发生错误', message: e.message, raw: e})
          }
        },
        resetImport(){
          this.confirmDialog_white.activated = false
          this.confirmDialog_black.activated = false
          this.addWhiteList = []
          this.addBlackList = []
        },
        resetImportDialog () {
          this.importErrorDialog_black = {
            activate: false,
            vehicles: [],
            fails: [],
            duplicates: [],
            haveDuplicatePlate: false,
          }
          this.importErrorDialog_white = {
            activate: false,
            vehicles: [],
            fails: [],
            duplicates: [],
            haveDuplicatePlate: false,
          }
        },
        importWhiteUsers (whiteUsers) {
          if (whiteUsers) {
            this.addWhiteList = []
            this.addWhiteList.push(...whiteUsers)
            this.confirmDialog_white.activated = true
          }
          this.resetImportDialog()
        },
        importBlackUsers (blackUsers) {
          if (blackUsers) {
            this.addBlackList = []
            this.addBlackList.push(...blackUsers)
            this.confirmDialog_black.activated = true
          }
          this.resetImportDialog()
        },
        checkUser (v) {
          if(v.loginId === ''){
            return '1'
          }else if(v.name === ''){
            return '2'
          }else if(v.orgName === ''){
            return '3'
          }
          return 0
        },
        isEmpty(v){
          return v.loginId===''&&v.name===''&&v.orgName===''
        },
        readExcel_white (files) {
          let f = files[0]
          if (!(f instanceof File)) return
          let reader = new FileReader()
          reader.onload = (event) => {
            try {
              let data = event.target.result
              let workbook = XLSX.read(data, {type: 'array'})
              let keys = Object.keys(workbook.Sheets)
              if (Object.keys(workbook.Sheets).length < 1) {
                throw Error('模板格式错误')
              }
              let sheet = workbook.Sheets[keys[0]]
              let ref = sheet['!ref']
              let group = /^[A-Z]+(\d+):[A-Z]+(\d+)$/.exec(ref)
              if (!group) {
                throw Error('模板格式错误')
              }
              let s = Number(group[1])
              let e = Number(group[2])
              console.log(sheet)

              let atters = ['A', 'B', 'C', 'D', 'E', 'F','G','H','I']
              let whiteUsers = []
              let fails = []
              let duplicates = []
              let haveDuplicatePlate = false

              for (let i = s + 1; i <= e; ++i) {
                let loginId = sheet[atters[0] + i] ? sheet[atters[0] + i].w.trim() : ''
                let name = sheet[atters[1] + i] ? sheet[atters[1] + i].w : ''
                let phone = sheet[atters[2] + i] ? sheet[atters[2] + i].w.trim() : ''
                let orgName = sheet[atters[3] + i] ? sheet[atters[3] + i].w.trim() : ''
                let v = {
                  loginId:loginId,
                  name:name,
                  phone:phone,
                  orgName:orgName
                }
                if(this.isEmpty(v)){
                  continue
                }
                let checkRes = this.checkUser(v)
                if (checkRes === 0) {
                  if (this.addWhiteList.find(t => (t.loginId === v.loginId))) {
                    duplicates.push(v)
                  }
                  else {
                    let tmp = whiteUsers.find(t => (t.loginId === v.loginId))
                    if (tmp) {
                      console.log('find duplicate', tmp, v,i)
                      haveDuplicatePlate = true
                    }
                    else {
                      whiteUsers.push(v)
                    }
                  }
                }
                else{
                  v.error = checkRes
                  fails.push(v)
                }
              }

              console.log('check import', fails, duplicates, whiteUsers)
              if (fails.length === 0 && duplicates.length === 0 && !haveDuplicatePlate) {
                this.importWhiteUsers(whiteUsers)
              }
              else {
                this.importErrorDialog_white = {
                  activate: true,
                  vehicles: whiteUsers,
                  fails: fails,
                  duplicates: duplicates,
                  haveDuplicatePlate: haveDuplicatePlate,
                }
              }
            }
            catch (e) {
              console.log(e)
              this.$L.alert({title: '读取导入模板时发生错误', message: '给定的文件格式错误，或浏览器版本不支持'})
            }
          }
          reader.readAsArrayBuffer(f)
        },
        readExcel_black (files) {
          let f = files[0]
          if (!(f instanceof File)) return
          let reader = new FileReader()
          reader.onload = (event) => {
            try {
              let data = event.target.result
              let workbook = XLSX.read(data, {type: 'array'})
              let keys = Object.keys(workbook.Sheets)
              if (Object.keys(workbook.Sheets).length < 1) {
                throw Error('模板格式错误')
              }
              let sheet = workbook.Sheets[keys[0]]
              let ref = sheet['!ref']
              let group = /^[A-Z]+(\d+):[A-Z]+(\d+)$/.exec(ref)
              if (!group) {
                throw Error('模板格式错误')
              }
              let s = Number(group[1])
              let e = Number(group[2])
              console.log(sheet)

              let atters = ['A', 'B', 'C', 'D', 'E', 'F','G','H','I']
              let blackUsers = []
              let fails = []
              let duplicates = []
              let haveDuplicatePlate = false

              for (let i = s + 1; i <= e; ++i) {
                let loginId = sheet[atters[0] + i] ? sheet[atters[0] + i].w.trim() : ''
                let name = sheet[atters[1] + i] ? sheet[atters[1] + i].w : ''
                let phone = sheet[atters[2] + i] ? sheet[atters[2] + i].w.trim() : ''
                let orgName = sheet[atters[3] + i] ? sheet[atters[3] + i].w.trim() : ''
                let v = {
                  loginId:loginId,
                  name:name,
                  phone:phone,
                  orgName:orgName
                }
                if(this.isEmpty(v)){
                  continue
                }
                let checkRes = this.checkUser(v)
                if (checkRes === 0) {
                  if (this.addBlackList.find(t => (t.loginId === v.loginId))) {
                    duplicates.push(v)
                  }
                  else {
                    let tmp = blackUsers.find(t => (t.loginId === v.loginId))
                    if (tmp) {
                      console.log('find duplicate', tmp, v,i)
                      haveDuplicatePlate = true
                    }
                    else {
                      blackUsers.push(v)
                    }
                  }
                }
                else{
                  v.error = checkRes
                  fails.push(v)
                }
              }

              console.log('check import', fails, duplicates, blackUsers)
              if (fails.length === 0 && duplicates.length === 0 && !haveDuplicatePlate) {
                this.importBlackUsers(blackUsers)
              }
              else {
                this.importErrorDialog_black = {
                  activate: true,
                  vehicles: blackUsers,
                  fails: fails,
                  duplicates: duplicates,
                  haveDuplicatePlate: haveDuplicatePlate,
                }
              }
            }
            catch (e) {
              console.log(e)
              this.$L.alert({title: '读取导入模板时发生错误', message: '给定的文件格式错误，或浏览器版本不支持'})
            }
          }
          reader.readAsArrayBuffer(f)
        },
        async getUsers (val) {
          try {
            let {items} = await this.$store.dispatch('userAdmin/getUsers', {
              pagination: {page: 1, rowsPerPage: 100},
              search: {key: 'name', value: val || ''}
            })
            return items
          }
          catch (e) {
            this.$L.alert('error', e.message)
            return []
          }
        },
        async addWhite(type='normal'){
            let arr = []
            for(let i=0;i<this.addWhiteList.length;i++){
              if(type==='normal'){
                let info = null
                try {
                  info = await this.$store.dispatch('login/getThemSelfInfo',this.addWhiteList[i].loginId)
                }catch (e) {
                  this.$L.alert('error',{message:e.toString()})
                  return
                }
                let obj = {
                  "name":this.addWhiteList[i].name,
                  "loginId":this.addWhiteList[i].loginId,
                  "phone":this.addWhiteList[i].phone,
                  'orgName':info.selfConfig.currentOrg===undefined?'':info.selfConfig.currentOrg.name,
                }
                arr.push(obj)
              }else {
                let obj = {
                  "name": this.addWhiteList[i].name,
                  "loginId": this.addWhiteList[i].loginId,
                  "phone": this.addWhiteList[i].phone,
                  'orgName': this.addWhiteList[i].orgName,
                }
                arr.push(obj)
              }
            }
            console.log(arr)
            let params = {"tempAuditReq":arr}
            try {
              let res = await this.$store.dispatch('school/addWhite',params)
              if(res.data.status === 1){
                this.$L.alert('success',{message:'添加成功'})
                this.addWhiteList = []
                this.$refs.whiteList.refresh()
              }else{
                this.$L.alert('error',{message:'添加失败，原因:'+res.data.msg})
              }
            }catch (e) {

            }finally {
              this.resetImport()
            }
        },
        async addBlack(type='normal'){
          let arr = []
          for(let i=0;i<this.addBlackList.length;i++){
            if(type === 'normal'){
              let info = null
              try {
                info = await this.$store.dispatch('login/getThemSelfInfo',this.addBlackList[i].loginId)
              }catch (e) {
                this.$L.alert('error',{message:e.toString()})
                return
              }
              let obj = {
                "name":this.addBlackList[i].name,
                "loginId":this.addBlackList[i].loginId,
                "phone":this.addBlackList[i].phone,
                'orgName':info.selfConfig.currentOrg===undefined?'':info.selfConfig.currentOrg.name,
              }
              arr.push(obj)
            }else{
              let obj = {
                "name": this.addBlackList[i].name,
                "loginId": this.addBlackList[i].loginId,
                "phone": this.addBlackList[i].phone,
                'orgName': this.addBlackList[i].orgName,
              }
              arr.push(obj)
            }
          }
          console.log(arr)
          let params = {"tempAuditReq":arr}
          try {
            let res = await this.$store.dispatch('school/addBlack',params)
            if(res.data.status === 1){
              this.$L.alert('success',{message:'添加成功'})
              this.addBlackList = []
              this.$refs.blackList.refresh()
            }else{
              this.$L.alert('error',{message:'添加失败，原因:'+res.data.msg})
            }
          }catch (e) {

          }finally {
            this.resetImport()
          }
        },
        async deleteTeacherConfirm (item) {
          let {res, close} = await this.$L.confirm({
            title: '确认从名单中删除该教工？',
            text: '教工名称:' + item.name
          })
          if (res) {
            try {
              await this.deleteTeacher(item)
            }
            catch (e) {
              this.$L.alert('error', e.message)
            }
          }
          close()
        },
        async deleteTeacher (item) {
          let ids = []
          ids.push(item.id)
          let params = {"ids":ids}
          let res = await this.$store.dispatch('school/deleteTeachers', params)
          if (res.data.status + '' === '1') {
            this.$L.alert('success', {message: '删除成功'})
            this.$refs.blackList.refresh()
            this.$refs.whiteList.refresh()
          }
          else {
            this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
          }
        },
        async deleteBlackTeachersConfirm(){
          let {res, close} = await this.$L.confirm({
            title: '确认从黑名单中删除选中的教师？',
          })
          if (res) {
            try {
              await this.deleteBlackTeachers()
            }
            catch (e) {
              this.$L.alert('error', e.message)
            }
          }
          close()
        },
        async deleteBlackTeachers () {
          let ids = []
          for(let i=0;i<this.selected_black.length;i++){
            let t = this.selected_black[i]
            ids.push(t.id)
          }
          let params = {"ids":ids}
          let res = await this.$store.dispatch('school/deleteTeachers', params)
          if (res.data.status + '' === '1') {
            this.$L.alert('success', {message: '删除成功'})
            this.$refs.blackList.refresh()
          }
          else {
            this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
          }
        },
        async deleteWhiteTeachersConfirm(){
          let {res, close} = await this.$L.confirm({
            title: '确认从白名单中删除选中的教师？',
          })
          if (res) {
            try {
              await this.deleteWhiteTeachers()
            }
            catch (e) {
              this.$L.alert('error', e.message)
            }
          }
          close()
        },
        async deleteWhiteTeachers () {
          let ids = []
          for(let i=0;i<this.selected_white.length;i++){
            let t = this.selected_white[i]
            ids.push(t.id)
          }
          let params = {"ids":ids}
          let res = await this.$store.dispatch('school/deleteTeachers', params)
          if (res.data.status + '' === '1') {
            this.$L.alert('success', {message: '删除成功'})
            this.$refs.whiteList.refresh()
          }
          else {
            this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
          }
        },
      }
    }
</script>

<style scoped>

</style>
